import { ENV_TYPE } from "./declarations/message";

class Logger {
    private env:ENV_TYPE;

    constructor(env:ENV_TYPE){
        this.env = env;
    }

    log(message?:any ,...optionalArg:any[]):void{
        if(this.env !== 'prod'){
        console.log(message,optionalArg);
        }
    }
    info(message?:any ,...optionalArg:any[]):void{
        if(this.env !== 'prod'){
        console.info(message,optionalArg);
        }
    }
    error(message?:any ,...optionalArg:any[]):void{
        console.error(message,optionalArg);
    }

    setLogLevel(env:ENV_TYPE):void{
        this.env = env; 
        if(env === 'local'){
            console.info('ENV set to "local" ');
            console.info('Current Environment for Login Utility is set for "local" . which means default functionality and behaviour of login utility would not work . If this was unintended please change the environment via TokenManager Instance.')
        }else if(env === 'dev'){
            console.info('ENV set to "dev" ');
        }
    }
}

export default Logger;